export enum Timeliness {
    Stale = 'stale',
    Fresh = 'fresh',
    Unknown = 'unknown',
}
